/**
 * i18n configuration for GotRedFlags.
 * Supports 12 Indian languages + English.
 */

export const locales = [
  "en",   // English
  "hi",   // Hindi
  "ta",   // Tamil
  "te",   // Telugu
  "kn",   // Kannada
  "ml",   // Malayalam
  "mr",   // Marathi
  "bn",   // Bengali
  "gu",   // Gujarati
  "pa",   // Punjabi
  "or",   // Odia
  "as",   // Assamese
] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

// Map our locale codes to display names (in native script)
export const localeNames: Record<Locale, string> = {
  en: "English",
  hi: "हिंदी",
  ta: "தமிழ்",
  te: "తెలుగు",
  kn: "ಕನ್ನಡ",
  ml: "മലയാളം",
  mr: "मराठी",
  bn: "বাংলা",
  gu: "ગુજરાતી",
  pa: "ਪੰਜਾਬੀ",
  or: "ଓଡ଼ିଆ",
  as: "অসমীয়া",
};

// Map our DB language names to locale codes
export const languageToLocale: Record<string, Locale> = {
  english: "en",
  hindi: "hi",
  tamil: "ta",
  telugu: "te",
  kannada: "kn",
  malayalam: "ml",
  marathi: "mr",
  bengali: "bn",
  gujarati: "gu",
  punjabi: "pa",
  odia: "or",
  assamese: "as",
};

export const localeToLanguage: Record<Locale, string> = {
  en: "english",
  hi: "hindi",
  ta: "tamil",
  te: "telugu",
  kn: "kannada",
  ml: "malayalam",
  mr: "marathi",
  bn: "bengali",
  gu: "gujarati",
  pa: "punjabi",
  or: "odia",
  as: "assamese",
};
